var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFactory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "A2 - Assign an ACI"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-6862 -612C-6862 -613.105 -6861.1 -614 -6860 -614H6165C6166.1 -614 6167 -613.105 6167 -612V988C6167 989.105 6166.1 990 6165 990H-6860C-6861.1 990 -6862 989.105 -6862 988V-612Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Detalle card b"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -275.5,
    y: -533.5,
    width: 1511,
    height: 1218,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "O1 Supervisor 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 571"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 883"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cards"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Card",
    filter: "url(#filter0_d_770_746)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -32,
    y: -78,
    width: 472,
    height: 152,
    rx: 4,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 885"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Atoms/Buttons/Item + Text"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -12,
    y: -6,
    width: 189,
    height: 36,
    rx: 6,
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "24px / factory",
    clipPath: "url(#clip0_770_746)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 299"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.9 3C3.66131 3 3.43239 3.09482 3.2636 3.2636C3.09482 3.43239 3 3.66131 3 3.9V20.1C3 20.3387 3.09482 20.5676 3.2636 20.7364C3.43239 20.9052 3.66131 21 3.9 21H20.1C20.3387 21 20.5676 20.9052 20.7364 20.7364C20.9052 20.5676 21 20.3387 21 20.1V8.5584C20.9999 8.40273 20.9595 8.24974 20.8826 8.11438C20.8057 7.97902 20.695 7.86591 20.5613 7.78611C20.4277 7.70631 20.2756 7.66255 20.12 7.65909C19.9643 7.65564 19.8105 7.69261 19.6734 7.7664L14.7 10.4412V8.5584C14.6999 8.40273 14.6595 8.24974 14.5826 8.11438C14.5057 7.97902 14.395 7.86591 14.2613 7.78611C14.1277 7.70631 13.9756 7.66255 13.82 7.65909C13.6643 7.65564 13.5105 7.69261 13.3734 7.7664L8.4 10.4412V3.9C8.4 3.66131 8.30518 3.43239 8.1364 3.2636C7.96761 3.09482 7.73869 3 7.5 3H3.9ZM4.8 9.1416V4.8H6.6V11.9469C6.60008 12.1026 6.64054 12.2556 6.71742 12.3909C6.79431 12.5263 6.90499 12.6394 7.03865 12.7192C7.17231 12.799 7.32439 12.8428 7.48002 12.8462C7.63566 12.8497 7.78953 12.8127 7.9266 12.7389L12.9 10.065V11.9469C12.9001 12.1026 12.9405 12.2556 13.0174 12.3909C13.0943 12.5263 13.205 12.6394 13.3387 12.7192C13.4723 12.799 13.6244 12.8428 13.78 12.8462C13.9357 12.8497 14.0895 12.8127 14.2266 12.7389L19.2 10.065V19.2H4.8V9.1416ZM9.3 15.15C9.3 14.9113 9.20518 14.6824 9.0364 14.5136C8.86761 14.3448 8.63869 14.25 8.4 14.25C8.1613 14.25 7.93239 14.3448 7.7636 14.5136C7.59482 14.6824 7.5 14.9113 7.5 15.15V16.95C7.5 17.1887 7.59482 17.4176 7.7636 17.5864C7.93239 17.7552 8.1613 17.85 8.4 17.85C8.63869 17.85 8.86761 17.7552 9.0364 17.5864C9.20518 17.4176 9.3 17.1887 9.3 16.95V15.15ZM12 14.25C12.2387 14.25 12.4676 14.3448 12.6364 14.5136C12.8052 14.6824 12.9 14.9113 12.9 15.15V16.95C12.9 17.1887 12.8052 17.4176 12.6364 17.5864C12.4676 17.7552 12.2387 17.85 12 17.85C11.7613 17.85 11.5324 17.7552 11.3636 17.5864C11.1948 17.4176 11.1 17.1887 11.1 16.95V15.15C11.1 14.9113 11.1948 14.6824 11.3636 14.5136C11.5324 14.3448 11.7613 14.25 12 14.25ZM16.5 15.15C16.5 14.9113 16.4052 14.6824 16.2364 14.5136C16.0676 14.3448 15.8387 14.25 15.6 14.25C15.3613 14.25 15.1324 14.3448 14.9636 14.5136C14.7948 14.6824 14.7 14.9113 14.7 15.15V16.95C14.7 17.1887 14.7948 17.4176 14.9636 17.5864C15.1324 17.7552 15.3613 17.85 15.6 17.85C15.8387 17.85 16.0676 17.7552 16.2364 17.5864C16.4052 17.4176 16.5 17.1887 16.5 16.95V15.15Z",
    fill: "#878787"
  }))))), /*#__PURE__*/React.createElement("rect", {
    x: -33,
    y: -79,
    width: 474,
    height: 154,
    rx: 5,
    stroke: "#4472C4",
    strokeWidth: 2,
    shapeRendering: "crispEdges"
  })))))), /*#__PURE__*/React.createElement("rect", {
    x: -275.5,
    y: -533.5,
    width: 1511,
    height: 1218,
    stroke: "#D6D6D6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-6860 -613H6165V-615H-6860V-613ZM6166 -612V988H6168V-612H6166ZM6165 989H-6860V991H6165V989ZM-6861 988V-612H-6863V988H-6861ZM-6860 989C-6860.55 989 -6861 988.552 -6861 988H-6863C-6863 989.657 -6861.66 991 -6860 991V989ZM6166 988C6166 988.552 6165.55 989 6165 989V991C6166.66 991 6168 989.657 6168 988H6166ZM6165 -613C6165.55 -613 6166 -612.552 6166 -612H6168C6168 -613.657 6166.66 -615 6165 -615V-613ZM-6860 -615C-6861.66 -615 -6863 -613.657 -6863 -612H-6861C-6861 -612.552 -6860.55 -613 -6860 -613V-615Z",
    fill: "black",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_770_746",
    x: -35,
    y: -80,
    width: 478,
    height: 159,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.3875 0 0 0 0 0.3875 0 0 0 0 0.3875 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_770_746"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_770_746",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_770_746"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactory);
export default __webpack_public_path__ + "static/media/factory.e7337ed87cdf7a11ad97e209b898a48b.svg";
export { ForwardRef as ReactComponent };